export default __webpack_public_path__ + "static/media/list_light.b874b15e.svg";